import React, { ReactElement, ReactNode, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import ArrowTickDown from "../../../../../../media/images/icons/arrow-tick-down";
interface Props {
  Icon: ReactElement;
  title: string;
}

const MyAccordion = ({ Icon, title }: Props) => {
  const [expanded, setExpanded] = useState(false);

  const theme = useTheme();

  const toggleAccordion = () => {
    setExpanded(!expanded);
  };

  return (
    <Box
      sx={{
        width: "100%",
        // overflow: "hidden",
        borderRadius: "10px",

        // transition: "height  ease-in-out", // Apply the transition here
        // height: expanded ? "200px" : "auto",
      }}
    >
      <Box
        onClick={toggleAccordion}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: "16px",
        }}
      >
        <Box
          sx={{
            cursor: "pointer",
            padding: "10px",
            display: "flex",
            alignItems: "center",
            paddingX: "15px",
            gap: "4px",
          }}
        >
          {Icon}
          <Typography>{title}</Typography>
        </Box>
        <ArrowTickDown size={12} color={theme.palette.textColor.main} />
      </Box>
      <Box
        sx={{
          transition: "all 0.5s",
          maxHeight: expanded ? "80px" : 0,
          overflow: "hidden",
          // border: "1px solid gray",
        }}
      >
        <Typography>
          برای مشاهده راهنمای ثبت‌نام هرکدام، کافی‌است بر روی آن ضربه بزنید:
        </Typography>
      </Box>
    </Box>
  );
};

export default MyAccordion;
